/* Zoom within the existing boxed viewer; mouse, touch and keyboard controls. */
class FioriDetailZoom extends HTMLElement {
  connectedCallback() {
    if (this.dataset.disabled === 'true') return;
    if (this.controller) return;
    this.controller = new AbortController(); const opts = { signal: this.controller.signal };
    this.scale = 1; this.x = 0; this.y = 0; this.points = new Map();
    this.button = document.createElement('button'); this.button.type = 'button'; this.button.className = 'fiori-zoom-toggle';
    this.button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M7 10h6"/><path class="fiori-zoom-plus" d="M10 7v6"/></svg>';
    this.append(this.button);
    this.button.addEventListener('click', event => { event.stopPropagation(); this.toggle(); }, opts);
    this.addEventListener('pointerdown', event => {
      if (event.target.closest('button') || (event.pointerType === 'mouse' && event.button !== 0)) return;
      this.setPointerCapture(event.pointerId); this.points.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (this.points.size === 1) { this.start = { x: event.clientX, y: event.clientY, tx: this.x, ty: this.y }; this.moved = false; }
      if (this.points.size === 2) {
        const a = [...this.points.values()]; this.pinch = { distance: Math.hypot(a[1].x-a[0].x,a[1].y-a[0].y), scale: this.scale, x:this.x,y:this.y,mid:this.mid(a) }; this.moved = true;
      }
    }, opts);
    this.addEventListener('pointermove', event => {
      if (!this.points.has(event.pointerId)) return;
      this.points.set(event.pointerId, {x:event.clientX,y:event.clientY});
      if (this.points.size === 2 && this.pinch) {
        const a=[...this.points.values()], mid=this.mid(a), ratio=Math.hypot(a[1].x-a[0].x,a[1].y-a[0].y)/Math.max(1,this.pinch.distance);
        this.scale=Math.max(1,Math.min(5,this.pinch.scale*ratio));
        const r=this.getBoundingClientRect(), k=this.scale/this.pinch.scale;
        this.x=mid.x-r.left-r.width/2-(this.pinch.mid.x-r.left-r.width/2-this.pinch.x)*k;
        this.y=mid.y-r.top-r.height/2-(this.pinch.mid.y-r.top-r.height/2-this.pinch.y)*k;
        this.paint(); return;
      }
      if (!this.start) return;
      const dx=event.clientX-this.start.x,dy=event.clientY-this.start.y;
      if(Math.hypot(dx,dy)>5)this.moved=true;
      if(this.scale>1){this.x=this.start.tx+dx;this.y=this.start.ty+dy;this.paint();}
    }, opts);
    const end = event => {
      if(!this.points.has(event.pointerId))return;
      const tap=this.points.size===1&&!this.moved&&event.type==='pointerup';
      this.points.delete(event.pointerId);
      if(tap)this.toggle(event.clientX,event.clientY);
      if(this.points.size){const pt=[...this.points.values()][0];this.start={x:pt.x,y:pt.y,tx:this.x,ty:this.y};this.moved=true;}
      else {this.start=null;this.pinch=null;}
    };
    this.addEventListener('pointerup',end,opts);this.addEventListener('pointercancel',end,opts);
    this.addEventListener('dragstart',event=>event.preventDefault(),opts);
    const dialog=this.closest('dialog'),media=this.closest('.product-media-container');
    this.observer=new MutationObserver(()=>this.reset());
    if(dialog)this.observer.observe(dialog,{attributes:true,attributeFilter:['open']});
    if(media)this.observer.observe(media,{attributes:true,attributeFilter:['hidden']});
    this.imageObserver=new MutationObserver(()=>this.paint());
    this.imageObserver.observe(this,{childList:true,subtree:true});
    this.resizeObserver=new ResizeObserver(()=>this.reset());this.resizeObserver.observe(this);
    this.paint();
  }
  mid(a){return{x:(a[0].x+a[1].x)/2,y:(a[0].y+a[1].y)/2};}
  toggle(clientX,clientY){
    if(this.scale>1){this.reset();return;}
    const r=this.getBoundingClientRect();this.scale=Number(this.dataset.scale)||2;
    this.x=(1-this.scale)*((clientX??(r.left+r.width/2))-r.left-r.width/2);
    this.y=(1-this.scale)*((clientY??(r.top+r.height/2))-r.top-r.height/2);this.paint();
  }
  reset(){this.scale=1;this.x=0;this.y=0;this.points?.clear();this.start=null;this.pinch=null;this.paint();}
  paint(){
    const image=this.querySelector('img');if(!image)return;
    const r=this.getBoundingClientRect(),ratio=image.naturalWidth/Math.max(1,image.naturalHeight);
    const w=Math.min(r.width,r.height*ratio)||r.width,h=Math.min(r.height,r.width/ratio)||r.height;
    const maxX=Math.max(0,(w*this.scale-r.width)/2),maxY=Math.max(0,(h*this.scale-r.height)/2);
    this.x=Math.max(-maxX,Math.min(maxX,this.x));this.y=Math.max(-maxY,Math.min(maxY,this.y));
    image.style.transform=`translate(${this.x}px,${this.y}px) scale(${this.scale})`;
    this.classList.toggle('is-zoomed',this.scale>1);
    if(this.button){this.button.setAttribute('aria-label',this.scale>1?this.dataset.out:this.dataset.in);this.button.setAttribute('aria-pressed',String(this.scale>1));this.button.title=this.button.getAttribute('aria-label');}
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();this.imageObserver?.disconnect();this.resizeObserver?.disconnect();this.button?.remove();}
}
if(!customElements.get('fiori-detail-zoom'))customElements.define('fiori-detail-zoom',FioriDetailZoom);
